import { getTicketById } from '../../api/TICKET/ticket';
import { useQuery } from '@tanstack/react-query';

export const useTicketById = (id) => {
  return useQuery({
    queryKey: ['ticket', id],
    queryFn: () => getTicketById(id),
    enabled: !!id,
    retry: false,
    staleTime: 2 * 60 * 1000,
  });
};
